import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Caractéristique } from '../models/caractéristique.model';
import { avecMethodesCaractéristiques } from './caractéristique.methods';
import { avecSélecteursCaractéristiques } from './caractéristique.selectors';

export const CaractéristiqueStore = signalStore(
  { providedIn: 'root' },
  withEntities<Caractéristique>(),
  avecMethodesCaractéristiques(),
  avecSélecteursCaractéristiques(),
);
